// extracted by mini-css-extract-plugin
module.exports = {"h1":"_2JlK263hDV0ukejTsKpcpJ","h2":"_1b609c9Iv_YG74HUuA2arx","h3":"_34ts24-PypCSJsozrW3wS2","h4":"_7a5RKMTM-niB9AvBVjYKB","h5":"_3ql1wZKg3HCre__k4JwOJn"};